<template>
	<div class="rebag" v-cloak>
		<div>
			<h1>{{ examDetail.examinationName }}网上报名系统</h1>
		</div>
		<div class="new-recenter">
			<div class="recenter">
				<div style="width: 580px;height: 480px;float: left;margin-top: 30px;">
					<img src="../assets/new-left.png" />
				</div>
				<div class="Land">
					<div class="topzi">用户登录</div>
					<el-form :model="ruleForm2" status-icon :rules="rules2" ref="ruleForm2" class="demo-ruleForm">
						<div class="demo-input-suffix">
							<el-form-item prop="name">
								<el-input placeholder="请输入报名序号" v-model="ruleForm2.name">
									<i slot="prefix" class="iconfont iconyonghuming"></i>
								</el-input>
							</el-form-item>
							<el-form-item prop="IDPass">
								<el-input placeholder="请输入身份证号" v-model="ruleForm2.IDPass" auto-complete="off">
									<i slot="prefix" class="iconfont iconId"></i>
								</el-input>
							</el-form-item>
							<el-form-item prop="pass">
								<el-input placeholder="请输入密码" type="password" v-model="ruleForm2.pass"
									auto-complete="off">
									<i slot="prefix" class="iconfont iconzu"></i>
								</el-input>
							</el-form-item>
							<loginCode v-if="$store.state.logincodeshow"></loginCode>
						</div>
						<el-form-item>
							<el-button type="primary" @click="submitForm('ruleForm2')" class="rebutton">登录</el-button>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="firstregister" class="rebutton_1">首次报考</el-button>
						</el-form-item>
						<div class="rehut">
							<p class="refot" @click="fortpas">找回密码报名序号</p>
							<p class="refot" @click="jindu" style="margin-left: 20PX;color: red;"
								v-show="examDetail.isPublic=='Y'">报名人数公示</p>
						</div>
					</el-form>
					<!--				<div class="chongzhi">-->
					<!--           <span @click="xuhao">找回报名序号</span>-->
					<!--				</div>-->
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>

</template>
<script>
	import Footer from '../components/common/footer.vue'
	import loginCode from '../components/logincode.vue'
	import {
		login,
		examDetail
	} from '@/api/api.js'
	import "@/assets/style/iconfont.css"
	import $ from "jquery";
	export default {
		name: "Register",
		components: {
			Footer,
			loginCode
		},
		data() {
			var validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入密码'));
				} else {
					callback();
				}
			};
			// var validatePass2 = (rule, value, callback) => {
			// 	if (value === '') {
			// 		callback(new Error('请输入身份证号'));
			// 	} else {
			// 		callback();
			// 	}
			// };
			const idCardValidity = (rule, code, callback) => {
				var city = {
					11: "北京",
					12: "天津",
					13: "河北",
					14: "山西",
					15: "内蒙古",
					21: "辽宁",
					22: "吉林",
					23: "黑龙江 ",
					31: "上海",
					32: "江苏",
					33: "浙江",
					34: "安徽",
					35: "福建",
					36: "江西",
					37: "山东",
					41: "河南",
					42: "湖北 ",
					43: "湖南",
					44: "广东",
					45: "广西",
					46: "海南",
					50: "重庆",
					51: "四川",
					52: "贵州",
					53: "云南",
					54: "西藏 ",
					61: "陕西",
					62: "甘肃",
					63: "青海",
					64: "宁夏",
					65: "新疆",
					71: "台湾",
					81: "香港",
					82: "澳门",
					91: "国外 "
				};
				var tip = ""
				var pass = true

				if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)) {
					tip = "身份证号格式错误"
					pass = false;
				} else if (!city[code.substr(0, 2)]) {
					tip = "地址编码错误"
					pass = false
				} else {
					// 18位身份证需要验证最后一位校验位
					if (code.length === 18) {
						code = code.split('')
						// ∑(ai×Wi)(mod 11)
						// 加权因子
						var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
						// 校验位
						var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
						var sum = 0
						var ai = 0
						var wi = 0
						for (var i = 0; i < 17; i++) {
							ai = code[i]
							wi = factor[i]
							sum += ai * wi
						}
						// var last = parity[sum % 11];
						if (parity[sum % 11] != code[17]) {
							tip = "校验位错误"
							pass = false
						}
					}
				}
				if (!pass) {
					callback(new Error(tip))
				} else {
					callback()
				}
				// if (!pass) alert(tip)
				// return pass
			}
			return {
				ruleForm2: {
					pass: '',
					IDPass: '',
					name: ''
				},
				rules2: {
					pass: [{
							required: true,
							message: "请输入密码",
							trigger: 'blur'
						},
						{
							required: true,
							validator: validatePass,
							trigger: 'blur'
						}
					],
					IDPass: [{
							required: true,
							message: "请输入身份证",
							trigger: 'blur'
						},
						{
							required: true,
							validator: idCardValidity,
							trigger: 'blur'
						}
					],
					name: [{
							required: true,
							message: '请输入报名序号',
							trigger: 'blur'
						},
						{
							pattern: /^(\w|-|[\u4E00-\u9FA5])*$/,
							message: '报名序号只能为数字',
							trigger: 'blur'
						}
					],
				},
				baomingshow: false,
				examDetail: {},
				showmsg: ""
			};
		},

		created() {
			document.querySelector('body').setAttribute('style', "background:#ffffff")
			var servetime = new Date($.ajax({
				type: "HEAD",
				async: false,
				cache: false
			}).getResponseHeader("Date"));
			if (this.$route.query.id) {
				this.$store.commit('updateExamId', this.$route.query.id)
				examDetail({
					"id": this.$route.query.id
				}).then(res => {
					this.examDetail = res.data.data;
					if (Date.parse(servetime) < Date.parse(res.data.data.signUpEndDate.replace(/-/g, "/")) && Date
						.parse(servetime) >
						Date.parse(res.data.data.signUpBeginDate.replace(/-/g, "/"))) {
						this.baomingshow = true
					}
					if (Date.parse(servetime) > Date.parse(res.data.data.signUpEndDate.replace(/-/g, "/"))) {
						this.showmsg = '本次考试报名已经结束！'
					} else if (Date.parse(servetime) < Date.parse(res.data.data.signUpBeginDate.replace(/-/g,
							"/"))) {
						this.showmsg = '本次考试报名还没开始，请耐心等待！'
					}

				})
			} else {
				this.$message({
					showClose: true,
					message: "请选择考试！",
					type: 'error'
				});
				this.$router.push({
					name: 'netbaoming'
				})
			}
		},
		methods: {
			firstregister() {
				if (!this.baomingshow) {
					this.$confirm(this.showmsg, '温馨提示', {
						showCancelButton: false,
						confirmButtonText: '我知道了',
						type: 'warning'
					}).then(() => {
						return false;
					})
					return false;
				} else {
					this.$store.commit('modifyfirstdo', 1);
					this.$router.push('/xieyi');
				}

			},
			submitForm(formName) {
				this.$store.commit('modifyfirstdo', 0);
				this.$refs[formName].validate((valid) => {
					console.log(valid, '11111111111111')
					if (valid) {
						if (this.$store.state.logincodeshow) {
							if (this.$store.state.logincodestatus) {
								login({
									'signUpNo': this.ruleForm2.name,
									'idCard': this.ruleForm2.IDPass,
									'pwd': this.ruleForm2.pass,
									'examinationId': this.$store.state.examid
								}).then(res => {
									if (res.data.code == 0) {
										this.$message({
											showClose: true,
											message: "登录成功！",
											type: 'success'
										});
										this.$store.commit('updateToken', res.data.msg);
										this.$store.commit('modifyfirstdo', 0);
										this.$store.commit('modifyshow', 1);
										if (this.$store.state.examid == 28 || this.$store.state.examid ==
											19) {
											this.$router.push({
												path: '/tianbaoxinxi'
											})
										}
										if (this.$store.state.examid == 23 || this.$store.state.examid ==
											34) {
											this.$router.push({
												path: '/tianbaoxinxi2'
											})
										}
									} else {
										this.$message({
											showClose: true,
											// message: res.data.msg,
											message: "登录信息有误，请确认！",
											type: 'error'
										});
									}
								})
							} else {
								this.$message({
									showClose: true,
									message: "验证码验证失败！",
									type: 'error',
								});
							}
						} else {
							login({
								'signUpNo': this.ruleForm2.name,
								'idCard': this.ruleForm2.IDPass,
								'pwd': this.ruleForm2.pass,
								'examinationId': this.$store.state.examid
							}).then(res => {
								if (res.data.code == 0) {
									this.$message({
										showClose: true,
										message: "登录成功！",
										type: 'success'
									});
									this.$store.commit('updateToken', res.data.msg);
									this.$store.commit('modifyfirstdo', 0);
									this.$store.commit('modifyshow', 1);
									console.log(this.$store.state.examid, "33333333333333")
									if (this.$store.state.examid == 28 || this.$store.state.examid == 19) {
										this.$router.push({
											path: '/tianbaoxinxi'
										})
									}
									if (this.$store.state.examid == 23 || this.$store.state.examid ==
										34) {
										this.$router.push({
											path: '/tianbaoxinxi2'
										})
									}
								} else if (res.data.code == 70101) {
									this.$message({
										showClose: true,
										message: "输入密码错误，请确认！",
										type: 'error'
									});
									if (res.data.data >= 3) {
										this.$store.commit('updateLogincodeshow', true)
									}
								} else {
									this.$message({
										showClose: true,
										// message: res.data.msg,
										message: "登录信息有误，请确认",
										type: 'error',
										duration: 5000
									});
								}
							})
						}
					} else {
						// console.log('error submit!!');
						// return false;

					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			},
			fortpas() {
				this.$router.push({
					path: '/fortpas'
				})

			},
			jindu() {
				this.$router.push({
					path: '/jindu'
				})

			},
			xuhao() {
				this.$router.push({
					path: '/xuhao'
				})

			}
		},
		beforeDestroy() {
			document.querySelector('body').removeAttribute('style')
		},
	}
</script>

<style scoped="">
	.rebag h1 {
		letter-spacing: 1.2px;
		color: #004B8E;
		margin-top: 2.5%;
		margin-bottom: 2%;
	}

	.new-recenter {
		background: url(../assets/new-bg.png) top center no-repeat;
		background-size: cover;
		background-repeat: no-repeat;
		background-position: top;
		bottom: 0px !important;
		width: 100% !important;
		float: left;
		padding-bottom: 3%;
		/* background-image: url("/i/bg_flower.gif");
		background-position: center center; 
		background-repeat: no-repeat; 
		background-attachment: scroll; 
		background-size: 100% auto;
		width:100%;
		height:1024px; */
	}

	.recenter {
		width: 1200px;
		height: 550px;
		margin: 0 auto;
		margin-top: 5.5%;
	}

	.recenter img {
		width: 580px;
		height: 480px;
		float: left;
	}

	#app .topzi {
		font-size: 28px;
		margin-bottom: 40px;
		color: #004B8E;

	}

	.Land {
		width: 400px;
		top: 20%;
		left: 0;
		right: 0;
		margin: 0 auto;
		padding: 20px 40px;
		float: right;
		margin-right: 2%;
		background-color: #ffffff;
		border-radius: 10px;
	}

	.demo-input-suffix i {
		font-size: 20px;
		color: #969696;
	}

	.el-input__inner {
		font-size: 15px !important;
		color: #000000 !important;
	}

	.rebutton {
		width: 100%;
		line-height: 24px;
		font-size: 20px;
		background-color: #ff9700;
		border: 1px solid #ff9700;
		margin-top: 0px;
		border-radius: 10px;
	}

	.rebutton_1 {
		width: 100%;
		line-height: 24px;
		font-size: 20px;
		background-color: #286DCD;
		margin-top: 0px;
		border-radius: 10px;
	}

	.refot {
		float: left;
		cursor: pointer;
	}

	.refiey {
		float: right;
		color: #df0000;
		cursor: pointer;
	}

	.chongzhi {
		float: left;
		width: 100%;
		text-align: center;
		margin-top: 10px;
	}

	.chongzhi span {
		margin-left: 5px;
		color: #2a83fe;
		cursor: pointer;
	}

	.fottext {
		width: 1200px;
		text-align: center;
		margin: 0 auto;
		margin-top: 5%;
		color: #000000;
		font-size: 14px;
	}

	footer {
		width: 100%;
		font-size: 16px;
		float: left;
	}

	.kfoter {
		margin: 0px 20px;
	}
</style>